export default function Input({ type, id, place, register, label }) {
  return <div className='flex flex-col'>
    <label className={labelName} htmlFor={id}>{label}</label>
    <input className={input} type={type} id={id} placeholder={place} {...register} />
  </div> 
}
const input = 'rounded border border-gray-700 p-1 outline-none text-sm w-96'
const labelName = 'text-xs text-main-darkest mb-1'
